<app-public-header></app-public-header>

<div class="welcome-wrap">
  <h3>Opt Out</h3>
  <p>{{ result }}</p>
</div>
<app-public-footer></app-public-footer>
